export const supportingDocumentRequired = [
  'BC',
  'PPE',
  'CC',
  'CN',
  'UC',
  'LB',
  'CB',
]

export const citizenSupportingDocumentNotRequired = [
  'PP',
  'EID',
  'TC',
  'FS',
  'DLE',
  'ETC',
]

export const nonCitizenSupportingDocumentNotRequired = ['ARU', 'RP', 'FP']
